// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import take from 'lodash/take';

import type { Product as ProductType } from '../../types/model';

import { getProductsByCategoryId } from '../../redux/selectors';

import Product from './Product';

const Root = styled.div`
  position: relative;

  display: flex;
  max-height: 510px;
`;

const ContentWrap = styled.div`
  flex: 1;

  display: flex;
  margin: 15px 90px;
`;

const ContentHeader = styled.h3`
  margin: 0 0 9px 0;

  font-weight: normal;
  font-size: 27px;

  color: ${props => props.color ? props.color : '#3C3C3C'};
`;

const Content = styled.div`
  flex: 1;
`

const ProductsList = styled.div`
  display: flex;
`

type Props = {
  products: Array<ProductType>,
  color: ?string,
}

function ProductsDrawer({ color, products }: Props) {
  if (products.length === 0) return null;

  return (
    <Root>
      <ContentWrap>
        <Content>
          <ContentHeader color={color}>
            Продукты
          </ContentHeader>

          <ProductsList>
            {products.map(product => (
              <Product
                key={product.id.toString()}
                id={product.id}
                title={product.title}
                imageUrl={(product.images && product.images.length > 0) ? (product.images[0].image.medium.url) : null}
                description={product.shortDescription}
              />
            ))}
          </ProductsList>
        </Content>
      </ContentWrap>
    </Root>
  );
}

function mapStateToProps(state, props) {
  const categoryId = props.match.params.id;

  return ({
    products: take(getProductsByCategoryId(state, categoryId), 3),
  })
}

export default connect(mapStateToProps)(ProductsDrawer);



// WEBPACK FOOTER //
// ./src/components/ProductsDrawer/ProductsDrawer.js